export * from './confirmed-pass.validator';
export * from './is-letters-and-numbers.validator';
export * from './only-letters-and-numbers.validator';
export * from './only-letters.validator';
